import { InvoiceStatusEnum } from 'domains-billing-types';

export function canMarkInvoiceAsBilled({
  status,
  invoiceDate,
  hasPermission,
}: {
  status: string;
  invoiceDate?: Date | string | null;
  hasPermission: boolean;
}): { isVisible: boolean; isEnabled: boolean } {
  const isVisible =
    hasPermission && status === InvoiceStatusEnum.EXTERNALLY_MANAGED;

  return { isVisible, isEnabled: isVisible && invoiceDate != null };
}
